
import React from "react";
import "../App.css";

import Aboutpage from "../Components/Aboutpage";
import Createuser from "../Components/Createuser";
import Footer from "../Components/Footer";

function About() {
  return (
     <>
     <Aboutpage/>
      {/* <Createuser/> */}
    
     </>
  );
}

export default About;
